/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
// 边界时间值，大于或者小于这个值，需要对页面中的状态进行延迟改变
export const borderExpire = 1
export enum StatusEnum {
  // 0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
  bet = 0,
  preparing = 1,
  showRes = 2,
}
export enum resStatusEnum {
  // 0: 未参与本轮;1:赢了;2:输了
  notInvolved = 0,
  win = 1,
  lose = 2,
}
export enum RankTypeEnum {
  // 榜单类型: 1: 日榜;2:周榜;3:月榜
  daily = 1,
  week,
  monthly,
}
export enum GameTypeEnum {
  猜宝箱 = 1,
  greedyHiya = 2,
  tp = 3,
  新转盘 = 4,
  slot = 5,
  greedypro = 6,
}
// 贪婪食物主页 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31594903
export const greedy_homepage = createAsyncThunk(
  'greedy_homepage',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'bet_prices'
          | 'coin_num'
          | 'day_rank'
          | 'day_round'
          | 'history_result'
          | 'max_select_foods'
          | 'normal_foods'
          | 'playing_users'
          | 'round_no'
          | 'round_status'
          | 'special_foods'
          | 'status_expire'
          | 'today_win_sum'
          | 'greedy_min_bet'
        >
      >
    >(
      '/live/game/greedy_homepage',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 贪婪食物主页 检查当前状态 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31594903
export const greedy_status = createAsyncThunk(
  'greedy_status',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'round_status'>>
    >(
      '/live/game/greedy_homepage',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 贪婪食物我的下注记录 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31595273
export const greedy_order_log = createAsyncThunk(
  'greedy_order_log',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'list'>>>(
      '/live/game/greedy_order_log',
      {
        ...store.getState().env.deviceinfo,
      },
      {store}
    )
    return resp.data.data
  }
)
// 获取贪婪食物开奖结果 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31596058
export const greedy_result = createAsyncThunk(
  'greedy_result',
  async (arg: {round_no: string}, store: any) => {
    // 每次获取开奖结果的时候将之前的结果清空
    await store.dispatch(GameGreedyHiyaSlice.actions.resetBetRes())
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'win_coins'
          | 'bet_amounts'
          | 'round_result'
          | 'round_rank'
          | 'status'
          | 'day_round'
          | 'extra_subsidy'
          | 'feature_game'
        >
      >
    >(
      '/live/game/greedy_result',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {store}
    )
    return resp.data.data
  }
)
const MAX_BET_QUEUE_LENGTH = 6
let GreedyBetRequestQueue = [] // 下注请求队列，限制长度为5
const loadingTimer = null
// [贪婪食物下注] https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31594953
export const getGreedyHiyaBet = createAsyncThunk(
  'getGreedyHiyaBet',
  async (
    {
      params,
      updateParams,
    }: {
      params: {bet_food: number; bet_amount: number; betId: number}
      updateParams: {betId: number}
    },
    store
  ) => {
    if (
      GreedyBetRequestQueue.length >= MAX_BET_QUEUE_LENGTH ||
      (GreedyBetRequestQueue[0] &&
        updateParams.betId - GreedyBetRequestQueue[0].betId > 1000)
    ) {
      // 最新加进来的离第一次下注的时候超过1s表示接口阻塞了，不能再加了，所以不能被加入到队列中去
      // store.dispatch(GameGreedyHiyaSlice.actions.changeBetLoading(true))
      // loadingTimer = setTimeout(() => {
      //   store.dispatch(GameGreedyHiyaSlice.actions.changeBetLoading(false))
      // }, 3000)
      return Promise.reject(new Error('下注过快'))
    }
    GreedyBetRequestQueue = [...GreedyBetRequestQueue, updateParams]
    const {bet_food, bet_amount} = params
    const resp = await http.post<HiyaRes<any>>(
      '/live/game/greedy_bet',
      {
        ...store.getState().env.deviceinfo,
        bet_food,
        bet_amount,
        // ...params,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const getGamesCallbackInfo = createAsyncThunk(
  'getGamesCallbackInfo',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/activity/games_callback_info',
      {
        ...deviceinfo,
        game_type: GameTypeEnum.greedyHiya,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const lucky_bonus_homepage = createAsyncThunk(
  'lucky_bonus_homepage',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/lucky_bonus_homepage',
      deviceinfo,
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export function useGreedyHiya() {
  return useSelector((store) => store.Animal_Cheetah)
}

interface res_type {
  food_id: number
  icon: string
}

export interface round_res_type extends res_type {
  big_reward_flag: boolean
  // 2 是披萨 1是沙拉
  big_reward_type?: 1 | 2
  round_no?: string
}
interface food_res_type extends res_type {
  name: string
}
export interface normal_food_res_type extends food_res_type {
  // 中奖赔率
  odds: number
  // 当前轮次下注热榜排名,默认值:0(忽略),大于0才有意义
  hot_topn: number
  // 当前用户在当前食物的下注金额
  bet_amounts: number
}
interface special_food_res_type extends normal_food_res_type {
  // 2 是披萨 1是沙拉
  type: 1 | 2
}
export interface order_log_list_type {
  round_no: string
  coin_num: number
  ct: string
}
interface round_rank_type {
  avatar: string
  coin_nums: number
  name: string
  rank_no: number
  zy_id: string
}
export interface free_card_info {
  value: number
  num: number
  game_type: GameTypeEnum
}
export interface recall_conf {
  op_free_cards_reward: Array<free_card_info>
  card_list: Array<free_card_info>
  freeCardListObj?: any
}
interface InitialStateType {
  hasPreLoadAct?: boolean
  // 引导页
  guideInfo?: {
    guideHint: string
    step2: boolean
  }
  // 主页面数据
  // 当前在线玩家
  playing_users?: number
  // 开奖轮次唯一性ID
  round_no?: string
  // 当前轮次/日
  day_round?: number
  // 金币余额
  coin_num?: number
  // 今日赢钱总数
  today_win_sum?: number
  // 普通食物列表
  normal_foods?: Array<normal_food_res_type>
  // 中大奖的食物列表
  special_foods?: Array<special_food_res_type>
  // 	当前轮次的状态:0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
  round_status?: number
  // 	当轮次状态为:开奖结果展示阶段时，展示开奖的结果
  round_result?: round_res_type
  // 	当前状态的剩余时间: 秒数
  status_expire?: number
  // 	用户单轮最多下注的食物种类
  max_select_foods?: number
  // 	单次可下注金额列表
  bet_prices?: Array<number>
  // 	历史期号开奖阶段，按开奖期号倒序排列
  history_result?: Array<round_res_type>
  // 	当日的中奖金额日榜top3
  day_rank?: Array<ListItemType>
  // 历史账单
  order_log_list?: Array<order_log_list_type>
  list?: Array<order_log_list_type>
  // 获取贪婪食物开奖结果
  // 防止和homePgae的day_round发生数据混淆
  res_day_round?: number
  // 赢取的金币数量
  win_coins?: number
  // 本轮下注总金额
  bet_amounts?: number
  // 本轮中奖金额top3
  round_rank?: Array<round_rank_type>
  // 本轮的状态:0: 未参与本轮;1:赢了;2:输了
  status?: resStatusEnum
  // ---界面---
  // 是否loading
  betLoading?: boolean
  // targetIndex?: number
  // 是否下注过，如果下注过的话就不需要展示手势
  betted?: boolean
  // 积分商城banner
  show_banner?: boolean
  // 积分商城的积分
  current_score?: number
  // 召回-免费金币卡
  recall?: recall_conf
  // 最小下注额
  greedy_min_bet?: {
    price: number
    countdown: number
  }
  // 额外补贴
  extra_subsidy?: {
    type: 1 | 2 | 3 | 4
    ratio: number
    num: number
  }
  // 天平二期
  feature_game?: {
    hit_targets: number[]
    reward_coins: number
  }
}

const initialState: InitialStateType = {}

const initData: InitialStateType = {
  hasPreLoadAct: false,
  guideInfo: {
    guideHint: 'yes',
    step2: false,
  },
  betLoading: true,
  betted: false,
  show_banner: false,
  recall: {
    op_free_cards_reward: [],
    card_list: [],
    freeCardListObj: {},
  },
}

export const GameGreedyHiyaSlice = createSlice({
  name: 'Animal_Cheetah',
  initialState,
  reducers: {
    initData: (state)=>{
       Object.assign(state, initData)
    },
    // hot_topn 当前轮次下注热榜排名,默认值:0(忽略),大于0才有意义
    updateHotFoods: (
      state,
      action: PayloadAction<{food_id: number; hot_topn: number}[]>
    ) => {
      if (!action.payload?.length) {
        return
      }
      const {normal_foods} = state
      normal_foods?.forEach((f, fIdx) => {
        const item = action.payload.find((nf) => nf.food_id === f.food_id)
        if (item) {
          normal_foods[fIdx].hot_topn = item.hot_topn || 0
        } else {
          // 如果更新的数组里面没有当前的下注物 就直接将当前的下注物置为不热门即可
          normal_foods[fIdx].hot_topn = 0
        }
      })
      Object.assign(state, {
        normal_foods,
      })
    },
    resetBetRes: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        win_coins: undefined,
        bet_amounts: undefined,
        round_result: undefined,
        round_rank: undefined,
        res_day_round: undefined,
      })
    },
    changeBetLoading: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        betLoading: action.payload,
      })
    },
    updateGuideInfo: (state, action: PayloadAction<any>) => {
      const {guideInfo} = state
      Object.assign(state, {
        guideInfo: {
          ...guideInfo,
          ...action.payload,
        },
      })
    },
    getWebMessage: (
      state,
      action: PayloadAction<{
        status_expire: number
        round_status: number
      }>
    ) => {
      Object.assign(state, action.payload)
    },
    updateRecall: (state, action: PayloadAction<any>) => {
      const {recall} = state
      Object.assign(state, {
        recall: {
          ...recall,
          ...action.payload,
        },
      })
    },
    finishedHasPreLoadAct: (state) => {
      Object.assign(state, {
        hasPreLoadAct: true,
      })
    },
  },
  extraReducers: (builder) => {
    // 贪婪食物主页
    builder.addCase(greedy_homepage.fulfilled, (state, action) => {
      const {round_status, normal_foods, greedy_min_bet, bet_prices} =
        action.payload
      if (greedy_min_bet) {
        bet_prices.unshift(greedy_min_bet.price)
      }
      // 默认的是否下注 是否的
      let betted = false
      // 只有是下注阶段的时候 才去检查是否有下注
      if (round_status === StatusEnum.bet) {
        betted = normal_foods?.some((f) => f.bet_amounts > 0)
      }
      Object.assign(state, action.payload, {betted, bet_prices})
    })
    // 贪婪食物下注
    builder.addCase(getGreedyHiyaBet.fulfilled, (state, action) => {
      clearTimeout(loadingTimer)
      GreedyBetRequestQueue.shift()
      const {normal_foods, coin_num} = action.payload
      // 默认的是否下注 是否的
      let betted = false
      betted = normal_foods?.some((f) => f.bet_amounts > 0)
      if (normal_foods?.length) {
        Object.assign(state, {normal_foods, coin_num, betted})
      }
    })
    builder.addCase(getGreedyHiyaBet.rejected, (state, action) => {
      // 这里有两种情况，一是不是下注阶段，二是超过限制长度，因为请求失效问题，
      // 前端其实判断选中的个数的时候是有延迟的，因为要涉及到下注和获取主页面数据两个接口
      // 说明有成功发起请求，不是后端的问题
      clearTimeout(loadingTimer)
      GreedyBetRequestQueue.shift()
    })
    // 贪婪食物历史账单
    builder.addCase(greedy_order_log.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    // 获取贪婪食物开奖结果
    builder.addCase(greedy_result.fulfilled, (state, action) => {
      const {round_result, day_round, ...rest} = action.payload
      // 直接在获取本轮结果之后获得对应数组的index
      const ret = {
        // 防止和homepage数据混淆
        res_day_round: day_round,
      }

      Object.assign(state, action.payload, rest, {round_result}, ret)
    })
    builder.addCase(getGamesCallbackInfo.fulfilled, (state, action) => {
      Object.assign(state, {
        recall: {
          ...state.recall,
          ...action.payload,
        },
      })
    })
  },
})
export default GameGreedyHiyaSlice.reducer
export const GameGreedyHiyaActions = GameGreedyHiyaSlice.actions
